import { Model } from "src/store/modelManagementSlice";

export const getMultiSelectFieldNames = (model: Model): string[] => {
  return Object.values(model.fields)
    .filter((field) => field.many)
    .map((field) => field.name);
};
